export enum SerialNumberTypes {
  None = 0,
  Random = 1,
  Consecutive = 2
}
